var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12522",
    "data-name": "Group 12522",
    transform: "translate(-1371 -743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 37,
    height: 33,
    rx: 3,
    transform: "translate(1371 743)",
    fill: "#2468ff",
    opacity: 0.072
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(1381 751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37619",
    "data-name": "Path 37619",
    d: "M9.172,7.137V0H7.137V7.137H0V9.172H7.137v7.137H9.172V9.172h7.137V7.137Z",
    fill: "#2179fe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAdd);
export default __webpack_public_path__ + "static/media/ImageAdd.9a421ba3.svg";
export { ForwardRef as ReactComponent };